/**
 * 썸네일 이미지 로드 동시성 제한 큐 (순차 렌더링)
 *
 * 저속 회선/속도제한에서 한 화면의 썸네일 수십 개가 동시에 요청되면 좁은 대역폭을
 * 서로 나눠 먹어 전부 느려진다. 이 큐는 실제로 진행 중인 이미지 로드를
 * MAX_CONCURRENT 개로 제한해, 뷰포트 진입 순서(≈DOM 순서)대로 N개씩 순차 로드한다.
 *
 * 사용:
 *   const cancel = acquireSlot(() => { ...로드 시작... })  // 슬롯 나면 콜백 실행
 *   releaseSlot()                                          // 로드 완료/실패 시 반납
 *   cancel()                                               // 대기 중 취소(언마운트)
 */

// 한 번에 진행할 이미지 로드 개수. 저속 회선에서 안정적인 값(3~5) 중 4.
const MAX_CONCURRENT = 4

let active = 0
const queue = []

function pump() {
  while (active < MAX_CONCURRENT && queue.length) {
    const task = queue.shift()
    if (task.cancelled) continue
    active += 1
    try {
      task.fn()
    } catch (_) {
      // 콜백에서 던져도 슬롯은 반납되어야 한다(호출측 release 누락 방어).
      active = Math.max(0, active - 1)
    }
  }
}

/**
 * 슬롯 획득 요청. 여유가 있으면 즉시, 없으면 대기 후 onGranted 실행.
 * @param {() => void} onGranted 슬롯 확보 시 호출(여기서 로드 시작)
 * @returns {() => void} 대기 취소 함수(아직 실행 전이면 큐에서 제거)
 */
export function acquireSlot(onGranted) {
  const task = { fn: onGranted, cancelled: false }
  queue.push(task)
  pump()
  return () => {
    task.cancelled = true
  }
}

/** 슬롯 반납 — 다음 대기 항목 진행 */
export function releaseSlot() {
  active = Math.max(0, active - 1)
  pump()
}
